<template>
  <!-- 底部 -->
  <footer style="width:100%;">
    <div class="box_0500">
      <div class="box_50 flex-col">
        <!-- <div class="image-wrapper_14 flex-row justify-between">
        <img
          class="image_9"
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng1c3f911af4034ececd02dfd6a920acf5b79ba43b7b99df0a2c60625cb9159a4a"
        />
        <img
          class="image_10"
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngb16e78701671d28975539bdc751bc2df9a4ccb93f0a68d6e79a208096a714262"
        />
        <img
          class="image_11"
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng27541f08c2807540649aaabdec3fcb9657570f52a7a9e253089d6d56a74da9f0"
        />
        <img
          class="image_12"
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng8a1d83eac4f1562f2ea4c6654e417c2ffdeb63400584363373eb439aeeed8aba"
        />
        <img
          class="image_13"
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngce2c7f06a5c5e16c49ac50c76d9731237fe40c33146b46f493c21a9bccffb66f"
        />
      </div>
      <div class="image-wrapper_15 flex-row">
        <img
          class="image_14"
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng835101d68a8133dcca952c58757fc3a9b7f43ea3700cc23da0813bbd73bb8ad3"
        />
        <img
          class="image_15"
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng792be6125ed85ee17d30a5dda74033c4e8f3520c147efaa44e4e23230e42c94e"
        />
        <img
          class="image_16"
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPnge4eb716f2c46721ed28ef2dd0603e2341a8a8368fb21534feb2dfc891fcc1ce3"
        />
        <img
          class="image_17"
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPnge992209ca2deee9f73b39c73e28ea7aed04a713b43e535162aa696738c8a9cb5"
        />
        <img
          class="image_18"
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngb8b57abe6d5a637005a54bebcc459b37ad112799df94075c30b24ce4d0b8621c"
        />
      </div> -->
        <div class="box_69 flex-row">
          <div class="group_67 flex-col">
            <span class="text_103">联系我们</span>
            <div class="image-text_128 flex-row justify-between">
              <img
                class="thumbnail_92"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngb967eada9114c0528c948793fa931731ebdd94ae74b194d8fb0de6a69ba6b8d9"
              />
              <span class="text-group_72"
                >客服微信：{{ gaunyuList.tb_weixin }}</span
              >
            </div>
            <div class="image-text_129 flex-row justify-between">
              <img
                class="thumbnail_93"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng2cf1ec528743438372bc0bcef28d92af62b7f9d4b9dd92e49292800f7c7ab1f0"
              />
              <span class="text-group_73"
                >工作日：{{ gaunyuList.tb_work_time }}</span
              >
            </div>
            <div class="image-text_130 flex-row justify-between">
              <img
                class="thumbnail_94"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng928f555da3dacfeb0a6319598a9ff35804348788576539d8c7259550ade47d29"
              />
              <span
                style="word-wrap: break-word; height: 44px;width: 196px;height: 44px;color: rgba(153, 153, 153, 1);font-size: 14px;text-align: justify;"
                >联系地址：{{ gaunyuList.tb_contact }}</span
              >
            </div>
            <div class="image-wrapper_16 flex-row justify-between">
              <img
                class="label_9"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng4d6e80c89ee4a83bed1b78d4508e41402384cc2048a4e855b7f112b1786bdd43"
              />
              <img
                class="label_10"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng73175763156f7877fb3e5ab29211b595376dfe9f624acde940ae805fa21744d0"
              />
              <img
                class="label_11"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngdf9bb5b97bb8d330b30510af71e3760745d32d1af9b1ab974012412e71c9910d"
              />
              <img
                class="label_12"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng90467decf60489c9921affa2c732bf3b2a509bb04d4886217fcace6643b1d35c"
              />
            </div>
          </div>
          <div class="group_43 flex-col"></div>
          <div class="text-wrapper_35 flex-col">
            <span class="text_104 ">首页</span>
            <span class="text_105 buts" @click="index(1)">学校信息库</span>
            <span class="text_106 buts" @click="index(2)">留学攻略</span>
            <span class="text_107 buts" @click="index(3)">学院信息对比</span>
            <span class="text_108 buts" @click="index(4)">留学资讯</span>
          </div>
          <div class="text-wrapper_36 flex-col">
            <span class="text_109">学院信息库</span>
            <span
              class="text_110 buts"
              :title="item.name"
              v-for="(item, index) in school_uuid"
              :key="index"
              @click="library(item.tb_school_uuid)"
              >{{ item.name }}</span
            >
          </div>
          <div class="text-wrapper_37 flex-col">
            <span class="text_115">留学攻略</span>
            <span
              class="text_110 buts"
              v-for="(item, index) in informationlist.date"
              :key="index"
              @click="strategy(item.tb_uuid)"
              :title="item.tb_title"
              >{{ item.tb_title }}</span
            >
          </div>
          <div class="text-wrapper_38 flex-col">
            <span class="text_120">留学问答</span>
            <span
              class="text_110 buts"
              :title="item.tb_title"
              v-for="(item, index) in Introductionlist"
              :key="index"
              @click="topic(item.tb_uuid)"
              >{{ item.tb_title }}</span
            >
          </div>
          <div class="text-wrapper_39 flex-col">
            <span class="text_126">关于我们</span>
            <span class="text_127 buts" @click="gome()">平台介绍</span>
            <span class="text_128 buts" @click="gome()">我们的理念</span>
            <span class="text_129 buts" @click="gome()">服务优势</span>
            <span class="text_130 buts" @click="gome()">联系我们</span>
          </div>
          <div class="group_44 flex-col"></div>
          <div class="image-text_131 flex-col justify-between">
            <div class="group_45 flex-col">
              <img
                :src="'api' + gaunyuList.tb_erweima"
                alt=""
              />
            </div>
            <span class="text-group_75">扫码添加微信</span>
          </div>
          <img
            class="image_19"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng37ee946c171fd2c6ef3171bbfbfae9d095f77480d49758d425ac20a0529cc93d"
          />
        </div>
        <div class="group_46 flex-col"></div>
        <span class="text_131"
          >Copyright©【NEW POWER CO.,LTD 日本留学资料馆 专业规划日本留学 欢迎来电咨询】&nbsp;辽ICP备2023004935号-2&nbsp;</span
        >
      </div>
    </div>
  </footer>
</template>
<script>
// import navbar from "../components/navbar/navbar.vue";
// import footer from "../components/footer/footer.vue";
// import article from "../components/article/article.vue";
import { GetGuanyu } from "../../api/guanyu";
import { GetSchool } from "../../api/school";
import { GetWenzhang } from "../../api/wenzhang";
export default {
  data() {
    return {
      gaunyuList: {},
      school_uuid: [],
      Introduction: {
        tb_sign: "1", //1表示查询咨询文章列表   2 表示查询攻略文章列表
        limit: "8", //一页显示条数
        page: "1" //当前页
      },
      Introductionlist: [],
      information: {
        tb_tuiguang: "", // 不维护，表示查询全部 1表示没上热门，0表示热门
        tb_type_title: "", //攻略列表
        tb_sign: "2", //1表示查询咨询文章列表   2 表示查询攻略文章列表
        limit: "8", //一页显示条数
        page: "1" //当前页
      },

      informationlist: []
    };
  },
  created() {
    this.getguanyu();
    this.getschool();
    this.getwenzhang();
    this.getwenzhangone();
  },
  methods: {
    library(id) {
      this.$router.push({
        path: "schooldetails",
        query: {
          id
        }
      });
    },
    async getwenzhangone() {
      const res = await GetWenzhang(this.Introduction);
      this.Introductionlist = res.data.date;
    },
    topic(id) {
      this.$router.push({
        path: "consult",
        query: {
          id
        }
      });
    },
    strategy(id) {
      this.$router.push({
        path: "study",
        query: {
          id
        }
      });
    },
    //客服、工作日、联系地址、微信二维码
    async getguanyu() {
      const response = await GetGuanyu();
      this.gaunyuList = response.data;
    },
    async getschool() {
      const res = await GetSchool();
      this.school_uuid = res.data.splice(0, 5);
    },
    async getwenzhang() {
      const res = await GetWenzhang(this.information);
      this.informationlist = res.data;
    },
    //区域检索学院
    index(i) {
      if (i == 1) {
        this.$router.push({
          path: "/schoolCommon"
        });
      } else if (i == 2) {
        this.$router.push({
          path: "/study"
        });
      } else if (i == 3) {
        this.$router.push({
          path: "/answers"
        });
      } else if (i == 4) {
        this.$router.push({
          path: "/consult"
        });
      }
    },
    gome() {
      this.$router.push({
        path: "/regard"
      });
    }
  }
};
</script>
<style src="../../../static/css/common.css" scoped></style>
<style src="../../../static/css/index.css" scoped />



// WEBPACK FOOTER //
// src/components/footer/footer.vue